import { useEffect } from "react";
import { useState } from "react";
import CreatePlanGroup from "../Section/CreatePlanGroup";
import UpdatePlanGroup from "../Section/UpdatePlanGroup";
import PlanGroupListItem from "./PlanGroupListItem";
import { Popconfirm } from "antd";

export default function PlanGroup(props) {
  let {
    plan = {},
    groupList = [],
    refresh = () => {},
    onClose = () => {},
    onDone = () => {},
    onBack = () => {},
    handleDiscord = () => {},
    isEditable,
  } = props;
  const [planGroup, setGroup] = useState({});
  const pending_history = planGroup.pending_history ? planGroup.pending_history : {};
  const hasUpdated = Boolean(pending_history && pending_history.updated_data);
  const [history, setHistory] = useState(false);

  useEffect(() => {
    refresh();
  }, []);

  const ActionComponent = planGroup.plan_group_id
    ? UpdatePlanGroup
    : CreatePlanGroup;
  return (
    <div className="row justify-content-center ">
      <div className="col-md-12">
        <div className="table-responsive border p-2">
          <table className="table questionnaire-table table-borderless mb-0">
            <thead>
              <tr className=" ">
                <td className="text-center">Plan Group Name</td>
                <td className="text-center">Sort Order</td>
                <td className="text-center">Minimum Days</td>
                <td className="text-center">Maximum Days</td>
                <td className="text-center">Start Interval</td>
                <td className="text-center">Action</td>
              </tr>
            </thead>
            <tbody>
              {groupList.length > 0 ? (
                groupList
                  .slice()
                  .filter((x)=>x?.active === true)
                  .sort((a, b) => a.sort_order - b.sort_order)
                  .map((item, i) => (
                    <PlanGroupListItem
                      item={item}
                      key={i}
                      isEditable={isEditable}
                      onEdit={setGroup}
                      canDelete={!plan.published}
                      refresh={refresh}
                      reset={() => setGroup({})}
                      setHistory={setHistory}
                    />
                  ))
              ) : (
                <tr>
                  <td className="text-center" colSpan="5">
                    No Plan Group Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      {isEditable && (
        <ActionComponent
          {...props}
          planGroup={planGroup}
          setGroup={setGroup}
          reset={() => setGroup({})}
        />
      )}
      <div className="d-flex align-items-end justify-content-center col-md-12 p-5">
        {isEditable && (hasUpdated || history) && (
          <Popconfirm
            title="Are you sure to discard and close?"
            onConfirm={handleDiscord}
            //  onCancel={cancel}
            okText="Yes"
            cancelText="No"
          >
            <button
              type="button"
              className="btn btn-danger btn-sm float-right btn-add-domain mr-2"
            >
              Discard All & Close
            </button>
          </Popconfirm>
        )}
        <button
          onClick={onClose}
          type="button"
          className="btn btn-danger btn-sm float-right btn-add-domain mr-2"
        >
          Close
        </button>{" "}
        <button
          onClick={onBack}
          type="button"
          className="btn btn-error btn-sm float-right btn-add-domain mr-2"
        >
          Back
        </button>
        {groupList.length > 0 && (
          <button
            onClick={onDone}
            type="button"
            className="btn btn-secondary btn-sm float-right btn-add-domain mr-2"
          >
            Next
          </button>
        )}
      </div>
    </div>
  );
}
